import { Col, Row } from 'antd';
import RatingCard from '../../../../ProfessionalReport/CompanyRatings/RatingCard';

const CreditScore = () => {
  const companyRatings = {
    defaultScore: {
      companyCode: '111689163',
      scoreDate: '2025-02-28T00:00:00Z',
      score: 680,
      ratingClass: '_7',
      pd: 3.03,
    },
    defaultScoreHistory: [
      {
        quarter: 'Q4',
        companyCode: '111689163',
        scoreDate: '2023-12-31T00:00:00Z',
        score: 721,
        ratingClass: '_6',
        pd: 1.197,
      },
      {
        quarter: 'Q1',
        companyCode: '111689163',
        scoreDate: '2024-03-31T00:00:00Z',
        score: 693,
        ratingClass: '_7',
        pd: 2.262,
      },
      {
        quarter: 'Q2',
        companyCode: '111689163',
        scoreDate: '2024-06-30T00:00:00Z',
        score: 693,
        ratingClass: '_7',
        pd: 2.262,
      },
      {
        quarter: 'Q3',
        companyCode: '111689163',
        scoreDate: '2024-09-30T00:00:00Z',
        score: 657,
        ratingClass: '_8',
        pd: 5.048,
      },
      {
        quarter: 'Q4',
        companyCode: '111689163',
        scoreDate: '2024-12-31T00:00:00Z',
        score: 680,
        ratingClass: '_7',
        pd: 3.03,
      },
    ],
    defaultScoreDistributionsBySector: [
      {
        id: 20853,
        ratingClass: 1,
        sectorId: 82,
        defaultCount: 0,
      },
      {
        id: 20941,
        ratingClass: 2,
        sectorId: 82,
        defaultCount: 0,
      },
      {
        id: 21029,
        ratingClass: 3,
        sectorId: 82,
        defaultCount: 14,
      },
      {
        id: 21117,
        ratingClass: 4,
        sectorId: 82,
        defaultCount: 161,
      },
      {
        id: 21205,
        ratingClass: 5,
        sectorId: 82,
        defaultCount: 253,
      },
      {
        id: 21293,
        ratingClass: 6,
        sectorId: 82,
        defaultCount: 349,
      },
      {
        id: 21381,
        ratingClass: 7,
        sectorId: 82,
        defaultCount: 110,
      },
      {
        id: 21469,
        ratingClass: 8,
        sectorId: 82,
        defaultCount: 16,
      },
      {
        id: 21557,
        ratingClass: 9,
        sectorId: 82,
        defaultCount: 2,
      },
      {
        id: 21645,
        ratingClass: 10,
        sectorId: 82,
        defaultCount: 13,
      },
    ],
    defaultScorePositiveAndNegativeFactors: {
      positiveFactorsReasonCodes: [
        'Age5',
        'Arr1',
        'Blf2',
        'Deb3',
        'Fid2',
        'Dir1',
        'Sod2',
        'Inf1',
        'Int1',
        'Def1',
        'Def3',
        'Fin3',
      ],
      negativeFactorsReasonCodes: ['Nac4', 'Inc1', 'Fin2', 'Fin6', 'Crt2'],
    },
    bankruptcyScore: {
      companyCode: '111689163',
      scoreDate: '2025-02-28T00:00:00Z',
      score: 792,
      ratingClass: '_5',
      pd: 0.234,
    },
    bankruptcyScoreHistory: [
      {
        quarter: 'Q4',
        companyCode: '111689163',
        scoreDate: '2023-12-31T00:00:00Z',
        score: 833,
        ratingClass: '_3',
        pd: 0.091,
      },
      {
        quarter: 'Q1',
        companyCode: '111689163',
        scoreDate: '2024-03-31T00:00:00Z',
        score: 833,
        ratingClass: '_3',
        pd: 0.091,
      },
      {
        quarter: 'Q2',
        companyCode: '111689163',
        scoreDate: '2024-06-30T00:00:00Z',
        score: 833,
        ratingClass: '_3',
        pd: 0.091,
      },
      {
        quarter: 'Q3',
        companyCode: '111689163',
        scoreDate: '2024-09-30T00:00:00Z',
        score: 783,
        ratingClass: '_5',
        pd: 0.288,
      },
      {
        quarter: 'Q4',
        companyCode: '111689163',
        scoreDate: '2024-12-31T00:00:00Z',
        score: 783,
        ratingClass: '_5',
        pd: 0.288,
      },
    ],
    bankruptcyScoreDistributionsBySector: [
      {
        id: 20853,
        ratingClass: 1,
        sectorId: 82,
        bankruptcyCount: 187,
      },
      {
        id: 20941,
        ratingClass: 2,
        sectorId: 82,
        bankruptcyCount: 197,
      },
      {
        id: 21029,
        ratingClass: 3,
        sectorId: 82,
        bankruptcyCount: 132,
      },
      {
        id: 21117,
        ratingClass: 4,
        sectorId: 82,
        bankruptcyCount: 47,
      },
      {
        id: 21205,
        ratingClass: 5,
        sectorId: 82,
        bankruptcyCount: 49,
      },
      {
        id: 21293,
        ratingClass: 6,
        sectorId: 82,
        bankruptcyCount: 259,
      },
      {
        id: 21381,
        ratingClass: 7,
        sectorId: 82,
        bankruptcyCount: 26,
      },
      {
        id: 21469,
        ratingClass: 8,
        sectorId: 82,
        bankruptcyCount: 24,
      },
      {
        id: 21557,
        ratingClass: 9,
        sectorId: 82,
        bankruptcyCount: 4,
      },
      {
        id: 21645,
        ratingClass: 10,
        sectorId: 82,
        bankruptcyCount: 4,
      },
    ],
    bankruptcyScorePositiveAndNegativeFactors: {
      positiveFactorsReasonCodes: ['Age7', 'Arr1', 'Blf2', 'Sod1', 'Deb3', 'Drb3', 'Dir1', 'Eqt2', 'Alt2', 'Csh1'],
      negativeFactorsReasonCodes: ['Nac4', 'Inc1', 'Crt2'],
    },
  };

  return (
    <Row>
      <Col span={24}>
        <>
          <Row
            gutter={[30, 30]}
            className="ant-row-pdf-gap no-break"
            style={{ pageBreakInside: 'avoid', pageBreakAfter: 'auto' }}
          >
            <Col className="flex" sm={24} md={24} lg={12} xl={12} xxl={12}>
              <RatingCard type="defaultRating" rating={companyRatings?.defaultScore} blur></RatingCard>
            </Col>
            <Col className="flex" sm={24} md={24} lg={12} xl={12} xxl={12}>
              <RatingCard type="bankruptcyRating" rating={companyRatings?.bankruptcyScore} blur></RatingCard>
            </Col>
          </Row>
        </>
      </Col>
    </Row>
  );
};

export default CreditScore;
